import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TpReferencePopupComponent } from './tp-reference-popup.component';
import { MaterialModule } from '../../material/material.module';
import { ChartModule } from 'angular-highcharts';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [TpReferencePopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ChartModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [TpReferencePopupComponent]
})
export class TpReferencePopupModule { }
